import React from 'react';
import { Button, CssBaseline, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import SubTitle from '../components/Text/SubTitle';

import { FiLogIn, FiCheck } from 'react-icons/fi';
import { FaMousePointer, FaRegKeyboard } from 'react-icons/fa';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { MdDownload } from 'react-icons/md';
import { BiPointer } from 'react-icons/bi';
import { ClassNames } from '@emotion/react';

const styles = (theme) => ({
  message: {
    padding: theme.spacing(2, 0, 5),
    color: '#555',
    textAlign: 'justifyContent',
    '& p': {
      marginBottom: '1.2em',
    },
  },
  divLine: {
    width: '100%',
    height: '1px',
    margin: theme.spacing(7, 0),
    backgroundColor: 'rgba(0,0,0,0.1)',
  },

  orderedList: {
    '& li': { fontWeight: 500, fontSize: '1.2em', lineHeight: 1.7 },
    '& span': {
      color: 'red',
      fontWeight: 'bold',
    },
  },
});

const StyledTableRow = withStyles((theme) => ({
  root: {
    color: '#000000',
    wordBreak: 'keep-all',
    '& th': { textAlign: 'center', fontWeight: 'bold', fontSize: '1.2em' },
    '& td': {
      fontWeight: 500,
      fontSize: '1.2em',
      '& p': {
        textIndent: '-0.65em',
        paddingLeft: '0.6em',
      },
    },
    // '&:nth-of-type(odd)': {
    //   '& th': {
    //     backgroundColor: '#cfdae6',
    //   },
    //   '& td': {
    //     backgroundColor: '#e6edf6',
    //   },
    // },
    // '&:nth-of-type(even)': {
    //   '& th': {
    //     backgroundColor: '#e9eff5',
    //   },
    //   '& td': {
    //     backgroundColor: '#f4f7fa',
    //   },
    // },
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  root: {
    border: '2px solid',
    borderColor: '#fff',
    fontSize: '1.2em',
    fontWeight: 500,
    // padding: '8px 0',
    backgroundColor: '#e9eef1',
    textAlign: 'center',
    wordBreak: 'keep-all',
  },
}))(TableCell);

const INFO_DATA = [
  { no: 2, icon: <BiPointer size={30} style={{ color: '#fff' }} />, text: 'Click the ‘Go’ button on the main page.' },
  { no: 3, icon: <FaRegKeyboard size={30} style={{ color: '#fff' }} />, text: 'Input information for each category.' },
  {
    no: 4,
    icon: <HiOutlineDocumentText size={30} style={{ color: '#fff' }} />,
    text: 'Select ‘Persons entering the country after 0:00p.m. September 3rd ‘ when entering negative test result confirmation information',
  },
  { no: 5, icon: <MdDownload size={30} style={{ color: '#fff' }} />, text: 'Download and print out the QR code issued after submission.' },
  {
    no: 6,
    icon: <FiCheck size={30} style={{ color: '#fff' }} />,
    text: 'When entering Korea, submit the QR code to the quarantine officer.',
  },
];

const RELATED_DATA = [
  { name: 'K-ETA', url: 'https://www.k-eta.go.kr/portal/apply/index.do?locale=EN', size: '20px' },
  { name: 'Q-CODE', url: 'https://cov19ent.kdca.go.kr/cpassportal/biz/beffatstmnt/main.do?lang=en', size: '20px' },
  { name: 'Incheon Airport', url: 'https://www.airport.kr/ap_cnt/en/svc/covid19/quaranti/quarantine.do ', size: '20px' },
  { name: 'Korea Disease Control and Prevention Agency COVID-19 Website', url: 'http://ncov.kdca.go.kr/en/', size: '14px' },
  { name: 'Ministry Foreign Affairs', url: 'https://www.mofa.go.kr/eng/index.do', size: '18px' },
];

class Covid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:992px)').matches,
    };
  }

  componentDidMount() {}

  render() {
    const { theme, classes } = this.props;
    const Content_padding_s = 16;
    // const Content_padding = 24;
    const Content_padding_l = 48;
    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={7} SIdx={4} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid container item xs={11} sm={10} md={9} lg={8}>
              <Grid item xs={12}>
                <MainTitle>COVID-19 Notice</MainTitle>
              </Grid>
              <Grid container alignItems="center" style={{ paddingBottom: Content_padding_l }}>
                <Typography style={{ fontSize: '1.2em', fontWeight: 'bold', lineHeight: 1.6 }}>
                  For all foreigners who wish to travel to Korea short or long term, please read the below information regarding COVID
                  regulations.
                </Typography>
              </Grid>
              <Grid container alignItems="center" style={{ paddingBottom: Content_padding_l }}>
                <SubTitle>No Pre-entry PCR Test</SubTitle>
                <ul className={classes.orderedList}>
                  <li>
                    Beginning September 3, 2022, 0:00 AM (Saturday), the requirement for inbound travelers to submit pre-entry inspections
                    (PCRs, RATs) and negative confirmations <span>will be suspended</span>, so please refer to this information if you are
                    entering Korea.
                  </li>
                  <br />
                  <li>
                    However, the duty to conduct the first inspection day after entering the country will remain in force. In this regard,
                    persons entering the country are required to undergo a first-day inspection and to report the results to the relevant
                    health center or the quarantine information pre-entry system (Q-code).
                  </li>
                </ul>
                <Grid container justifyContent="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      window.open('https://www.airport.kr/ap_cnt/en/svc/covid19/medical/medical.do', '_blank');
                    }}
                    style={{ textTransform: 'none', fontSize: '1.2em', padding: 'auto 20px' }}
                  >
                    More details arrival COVID-19 Test
                    <br />
                    (Incheon International Airport)
                  </Button>
                </Grid>
              </Grid>
              <Grid container style={{ paddingBottom: Content_padding_l }}>
                <SubTitle>COVID-19 Test Cost</SubTitle>

                <Grid container style={{ paddingTop: Content_padding_l }}>
                  <Typography style={{ fontSize: '1.2em', fontWeight: 'bold', lineHeight: 1.6 }}>1. Test Cost for Departure</Typography>
                  <Table>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          rowSpan={2}
                          width={'10%'}
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Category
                        </StyledTableCell>
                        <StyledTableCell
                          colSpan={2}
                          width={'45%'}
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          PCR Test
                        </StyledTableCell>

                        <StyledTableCell
                          width={'45%'}
                          colSpan={2}
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Antigen Test
                        </StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell
                          width={'20%'}
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Weekdays
                        </StyledTableCell>
                        <StyledTableCell
                          width={'25%'}
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Weekends
                          <br />
                          <b style={{ color: '#FFE13C' }}>(Weekdays 7AM~9AM / Holidays)</b>
                        </StyledTableCell>
                        <StyledTableCell
                          width={'20%'}
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Weekdays
                        </StyledTableCell>
                        <StyledTableCell
                          width={'25%'}
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Weekends
                          <br />
                          <b style={{ color: '#FFE13C' }}>(Weekdays 7AM~9AM / Holidays)</b>
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Koreans
                        </StyledTableCell>
                        <StyledTableCell>KRW 96,000</StyledTableCell>
                        <StyledTableCell>KRW 100,000</StyledTableCell>
                        <StyledTableCell>KRW 61,000</StyledTableCell>
                        <StyledTableCell>KRW 65,000</StyledTableCell>
                      </StyledTableRow>
                      <StyledTableRow>
                        <StyledTableCell
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Foreigners
                        </StyledTableCell>
                        <StyledTableCell>KRW 104,000</StyledTableCell>
                        <StyledTableCell>KRW 110,000</StyledTableCell>
                        <StyledTableCell>KRW 69,000</StyledTableCell>
                        <StyledTableCell>KRW 75,000</StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </Grid>

                <Grid container style={{ paddingTop: Content_padding_l }}>
                  <Typography style={{ fontSize: '1.2em', fontWeight: 'bold', lineHeight: 1.6 }}>2. Test Cost for Arrival</Typography>
                  <Table>
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          Category
                        </StyledTableCell>
                        <StyledTableCell
                          style={{
                            backgroundColor: '#237a9d',
                            color: theme.palette.common.white,
                            fontWeight: 'bold',
                            textAlign: 'center',
                          }}
                        >
                          PCR Test
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell>
                          <b>Arrival Passenger</b>
                        </StyledTableCell>
                        <StyledTableCell>KRW 80,000</StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                  <Typography style={{ fontSize: '1.2em', lineHeight: 1.6 }}>
                    <br />※ Who is able to take the arrival PCR test at Incheon Airport :&nbsp;
                    <span style={{ color: '#f00' }}>Foreigner with a short-term visa</span>
                  </Typography>
                </Grid>
              </Grid>

              <Grid container style={{}}>
                <SubTitle>Quarantine guideline for foreigners</SubTitle>
                <Typography style={{ fontSize: '1.2em', lineHeight: 1.6, paddingBottom: Content_padding_s }}>
                  <b>
                    No quarantine required regardless of vaccination status or visa type (only confirmed infection cases will be
                    quarantined).
                  </b>
                  <br />
                  <br />
                  <div style={{ width: '100%', display: 'flex' }}>
                    <span>*</span>
                    <span style={{ paddingLeft: 8 }}>
                      &nbsp;Mandatory quarantine for international arrivals has been lifted since July 25, 2022. All entrants from overseas
                      are strongly encouraged to register through the Q-CODE system before entry.
                    </span>
                  </div>
                </Typography>

                <Grid container style={{ paddingTop: Content_padding_s }}>
                  <Typography style={{ fontSize: '1.2em', fontWeight: 'bold', lineHeight: 1.6 }}>
                    1. Test Cost for Departure <br />
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;- Symptomatic cases
                    <br /> <br />
                  </Typography>
                </Grid>

                <Table>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        width={'20%'}
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Classification
                      </StyledTableCell>
                      <StyledTableCell
                        width={'25%'}
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        PCR test
                      </StyledTableCell>
                      <StyledTableCell
                        width={'15%'}
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Test result
                      </StyledTableCell>
                      <StyledTableCell
                        width={'40%'}
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Action
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell rowSpan={2}>
                        <b>Symptomatic entrants</b>
                      </StyledTableCell>
                      <StyledTableCell rowSpan={2}>
                        Arrival Hall or Central Quarantine and Medical Support Center (quarantine facility)
                      </StyledTableCell>
                      <StyledTableCell>
                        <b>Positive</b>
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'left' }}>
                        Transfer to one’s residence, hospital or residential treatment center.
                        <br />
                        (Seven day quarantine is required.)
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell>
                        <b>Negative</b>
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'left' }}>
                        Follow the asymptomatic case procedures for individuals
                        <br /> (There is no need to do the PCR test that is required within 24 hours after entry.)
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>

                <Typography style={{ fontSize: '1.2em', fontWeight: 'bold', lineHeight: 1.6 }}>
                  <br />
                  &nbsp;&nbsp;&nbsp;&nbsp;- Asymptomatic cases
                  <br /> <br />
                </Typography>

                <Table>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Classification
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        *Mandatory*
                        <br /> PCR test within 1 day after entry
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Quarantine
                      </StyledTableCell>
                      <StyledTableCell
                        style={{
                          backgroundColor: '#237a9d',
                          color: theme.palette.common.white,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Additional Test
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <StyledTableCell>
                        <b>Koreans / Long-stay foreigners</b>
                      </StyledTableCell>
                      <StyledTableCell>Public Health Center</StyledTableCell>
                      <StyledTableCell>Only those with confirmed infection are quarantined</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'left' }}>
                        RAT recommended on the sixth or seventh day after entering
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell>
                        <b>Short-stay foreigners</b>
                      </StyledTableCell>
                      <StyledTableCell>Airport COVID-19 Test Center or medical institution (at one’s own expense)</StyledTableCell>
                      <StyledTableCell>Only those with confirmed infection are quarantined</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'left' }}>
                        RAT recommended on the sixth or seventh day after entering
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>

                <Typography style={{ fontSize: '1.2em', lineHeight: 1.6 }}>
                  <br />※ You can enter the result of the PCR test done within 24 hours after entry on the ‘Registration of post-entry
                  inspection’ page on the Q-CODE website.
                </Typography>

                <Grid container style={{ paddingTop: Content_padding_l }}>
                  <Typography style={{ fontSize: '1.2em', fontWeight: 'bold', lineHeight: 1.6 }}>2. Test Cost for Departure</Typography>
                </Grid>

                <ul className={classes.orderedList}>
                  <li>
                    <b>Basic immigration procedure</b>
                    <br />
                    Checking quarantine information of all entrants. <br />
                    <br />
                  </li>
                  <li>
                    <b>Quarantine information</b>
                    <br />
                    Check health status and information, etc. of entrants.
                    <br />
                    <br />
                  </li>
                  <li>
                    <b>Q-CODE users:</b>
                    <br />
                    Present the issued QR code for the quarantine officer to scan and check the information.
                    <br />
                    <br />
                  </li>
                  <li>
                    <b>Non-Q-CODE users:</b>
                    <br />
                    Present the health status questionnaire for verification. After checking, the information is entered into the
                    immigration system.
                    <br />
                    <br />
                  </li>
                  <li>
                    <b>Quarantine Information Pre-entry System (Q-CODE)</b>
                    <br />- Registration is strongly encouraged for all passengers entering from overseas.
                    <br />- Q-CODE system users may report their health status by presenting the QR code (no additional documents required)
                    <br />- How to use the Q-CODE
                  </li>
                </ul>
              </Grid>

              <Grid
                container
                style={{ border: '1px solid #f9f9f9', backgroundColor: '#E9eeF1', padding: '50px 30px', marginTop: Content_padding_l }}
              >
                <Grid container style={{ marginBottom: 30 }}>
                  <Grid>
                    <Grid
                      container
                      justifyContent="center"
                      alignItems="center"
                      style={{
                        borderRadius: '50%',
                        backgroundColor: '#237a9d',
                        width: 50,
                        height: 50,
                      }}
                    >
                      <FiLogIn size={30} style={{ color: '#fff' }} />
                    </Grid>
                  </Grid>
                  <Grid style={{ paddingLeft: 20 }}>
                    <Grid item xs={12}>
                      <Typography style={{ fontWeight: 'bold', fontSize: '1.3em' }}> Step 1</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography style={{ fontSize: '1.2em' }}>
                        Access the Q-CODE website.
                        <br /> <br />
                      </Typography>
                      <Typography style={{ fontSize: '1.2em', lineHeight: 1.8, paddingLeft: 15 }}>
                        &#183;Korean:
                        <a href="https://cov19ent.kdca.go.kr/cpassportal/biz/beffatstmnt/main.do?lang=ko" target="_blank">
                          https://cov19ent.kdca.go.kr/cpassportal/biz/beffatstmnt/main.do?lang=ko
                        </a>
                        <br />
                        &#183;English:
                        <a href="https://cov19ent.kdca.go.kr/cpassportal/biz/beffatstmnt/main.do?lang=en" target="_blank">
                          https://cov19ent.kdca.go.kr/cpassportal/biz/beffatstmnt/main.do?lang=en
                        </a>
                        <br />* Q-CODE video:
                        <a href="https://www.youtube.com/watch?v=s0m9v8J8_dA&feature=share" target="_blank">
                          https://www.youtube.com/watch?v=s0m9v8J8_dA&feature=share
                        </a>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {INFO_DATA.map((items) => {
                  return (
                    <Grid container key={items.no} style={{ marginBottom: 30 }}>
                      <Grid>
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                          style={{
                            borderRadius: '50%',
                            backgroundColor: '#237a9d',
                            width: 50,
                            height: 50,
                          }}
                        >
                          {items.icon}
                        </Grid>
                      </Grid>
                      <Grid style={{ paddingLeft: 20 }}>
                        <Grid item xs={12}>
                          <Typography style={{ fontWeight: 'bold', fontSize: '1.3em' }}>Step&nbsp;{items.no}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography style={{ fontSize: '1.2em' }}>{items.text}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })}

                {/* 
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    borderRadius: '50%',
                    backgroundColor: '#237a9d',
                    width: 50,
                    height: 50,
                  }}
                >
                  <FaMousePointer size={30} style={{ color: '#fff' }} />
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    borderRadius: '50%',
                    backgroundColor: '#237a9d',
                    width: 50,
                    height: 50,
                  }}
                >
                  <FaRegKeyboard size={30} style={{ color: '#fff' }} />
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    borderRadius: '50%',
                    backgroundColor: '#237a9d',
                    width: 50,
                    height: 50,
                  }}
                >
                  <FiLogIn size={30} style={{ color: '#fff' }} />
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    borderRadius: '50%',
                    backgroundColor: '#237a9d',
                    width: 50,
                    height: 50,
                  }}
                >
                  <HiOutlineDocumentText size={30} style={{ color: '#fff' }} />
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    borderRadius: '50%',
                    backgroundColor: '#237a9d',
                    width: 50,
                    height: 50,
                  }}
                >
                  <MdDownload size={30} style={{ color: '#fff' }} />
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    borderRadius: '50%',
                    backgroundColor: '#237a9d',
                    width: 50,
                    height: 50,
                  }}
                >
                  <BsCheckLg size={30} style={{ color: '#fff' }} />
                </Grid> */}
              </Grid>

              <Grid container alignItems="center" style={{ paddingBottom: Content_padding_l, paddingTop: Content_padding_l }}>
                <SubTitle>Related Sites</SubTitle>
                <Grid container justifyContent="space-between" style={{ paddingTop: Content_padding_s }}>
                  {RELATED_DATA.map((b_items) => {
                    return (
                      <Button
                        color="primary"
                        variant="contained"
                        key={b_items.name}
                        onClick={() => {
                          window.open(`${b_items.url}`);
                        }}
                        style={{ width: '19%', textTransform: 'none', fontSize: `${b_items.size}` }}
                      >
                        {b_items.name}
                      </Button>
                    );
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Covid);
